module.exports = __webpack_public_path__ + "static/left-arrow.png";